/**
 * ListaFases - Lista de fases agrupadas por etapa macro
 */
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { Clock, Calendar } from 'lucide-react';
import CardFase from './CardFase';

const ListaFases = ({
  cronograma,
  fasesFiltradas,
  etapasMacro,
  factories,
  expandedFases,
  onToggleFaseExpand,
  onIniciarFase,
  onConcluirFase,
  onVerDetalhes,
  onToggleEtapa
}) => {
  // Estado vazio - sem cronograma
  if (!cronograma) {
    return (
      <Card>
        <CardContent className="py-12 text-center">
          <Clock className="mx-auto h-12 w-12 text-gray-400 mb-4" />
          <h3 className="text-lg font-medium text-gray-900 mb-2">
            Selecione um projeto e embarcação
          </h3>
          <p className="text-gray-500">
            O cronograma será carregado automaticamente
          </p>
        </CardContent>
      </Card>
    );
  }

  // Estado vazio - nenhuma fase no período
  if (fasesFiltradas.length === 0) {
    return (
      <Card>
        <CardContent className="py-12 text-center">
          <Calendar className="mx-auto h-12 w-12 text-gray-400 mb-4" />
          <h3 className="text-lg font-medium text-gray-900 mb-2">
            Nenhuma fase no período
          </h3>
          <p className="text-gray-500">
            Não há fases previstas para o período selecionado
          </p>
        </CardContent>
      </Card>
    );
  }

  // Agrupar por Etapa Macro - detecta dinamicamente TODOS os números presentes no cronograma
  // (antes era fixo em [1,2,3,4], escondendo etapas macro 5+ criadas em Configurações)
  const macrosPresentes = Array.from(new Set(
    fasesFiltradas.map(i => i.etapa_macro).filter(v => v !== null && v !== undefined)
  ));
  const etapasParaRenderizar = [
    ...macrosPresentes.sort((a, b) => {
      const ordA = etapasMacro.find(e => e.numero === a)?.ordem ?? a;
      const ordB = etapasMacro.find(e => e.numero === b)?.ordem ?? b;
      return ordA - ordB;
    }),
    'none'
  ];

  return (
    <div className="space-y-3" data-testid="lista-fases">
      {etapasParaRenderizar.map(etapaMacro => {
        const itensDaEtapa = fasesFiltradas
          .filter(i => 
            etapaMacro === 'none' 
              ? (!i.etapa_macro || i.etapa_macro === null || i.etapa_macro === undefined)
              : i.etapa_macro === etapaMacro
          )
          .sort((a, b) => (a.ordem ?? 0) - (b.ordem ?? 0));
        
        if (itensDaEtapa.length === 0) return null;
        
        const etapaMacroData = etapasMacro.find(e => e.numero === etapaMacro);
        const etapaNome = etapaMacro === 'none' 
          ? 'Outras Fases' 
          : (etapaMacroData?.nome || itensDaEtapa[0]?.etapa_macro_nome || `Etapa ${etapaMacro}`);
        
        return (
          <Card key={etapaMacro}>
            <CardHeader className="py-3 bg-gray-50">
              <CardTitle className="text-base flex items-center gap-2">
                {etapaMacro !== 'none' && (
                  <Badge variant="outline">{etapaMacro}</Badge>
                )}
                {etapaNome}
                <span className="text-sm font-normal text-gray-500">
                  ({itensDaEtapa.length} fases)
                </span>
              </CardTitle>
            </CardHeader>
            <CardContent className="p-0">
              <div className="divide-y">
                {itensDaEtapa.map((fase) => {
                  const fabrica = factories.find(f => f.id === fase.fabrica_id);
                  
                  return (
                    <CardFase
                      key={fase.id}
                      fase={fase}
                      fabrica={fabrica}
                      isExpanded={expandedFases[fase.id]}
                      onToggleExpand={onToggleFaseExpand}
                      onIniciar={onIniciarFase}
                      onConcluir={onConcluirFase}
                      onVerDetalhes={onVerDetalhes}
                      onToggleEtapa={onToggleEtapa}
                    />
                  );
                })}
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};

export default ListaFases;
